import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AirportPageRoutingModule } from './airport-routing.module';

import { AirportPage } from './airport.page';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AirportPageRoutingModule,
    NgxDatatableModule
  ],
  declarations: [AirportPage],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AirportPageModule {}
